// extracted by mini-css-extract-plugin
export default {"react_select_carrier_container":"ReactMultiSelect_react_select_carrier_container__Gbtv4"};